module.exports = __webpack_public_path__ + "img/t2.6991670f.png";